module.exports = __webpack_public_path__ + "static/media/naver_login_icon.b1644945.PNG";